import { FeedbackLevel } from '@payaca/types/feedbackTypes';
import {
  FunctionComponent,
  PropsWithChildren,
  useState,
  type JSX,
} from 'react';

import { Collapse } from '@mui/material';
import { Button } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import './FeedbackBlock.sass';

type Props = {
  feedbackLevel?: FeedbackLevel;
  className?: string;
  isDismissable?: boolean;
  onDismissed?: () => void;
};

const FeedbackBlock: FunctionComponent<PropsWithChildren<Props>> = ({
  children,
  feedbackLevel = FeedbackLevel.NEUTRAL,
  isDismissable,
  className,
  onDismissed,
}: PropsWithChildren<Props>): JSX.Element | null => {
  const [isDismissRequired, setIsDismissRequired] = useState(false);

  return (
    <Collapse
      className="collapsible-feedback-block"
      appear={true}
      in={!isDismissRequired}
      onExited={onDismissed}
    >
      <div
        className={`feedback-block feedback-level-${feedbackLevel} ${
          className ? className : ''
        }`}
      >
        <div>{children}</div>
        {isDismissable && (
          <Button
            className="dismiss-trigger"
            variant="link"
            onClick={() => setIsDismissRequired(true)}
          >
            <UntitledIcon name="x.3" />
          </Button>
        )}
      </div>
    </Collapse>
  );
};

export default FeedbackBlock;
